// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"22":"css/gutenberg","252":"css/app","262":"css/blocks/banner","931":"css/blocks/popular-excursions"}[chunkId] + ".css";
};